const NUMBER_RANGE_TYPE = {
  minAmount: 'from',
  maxAmount: 'to',
  bigger: 'bigger',
  smaller: 'smaller',
  exact: 'exact',
};

export default NUMBER_RANGE_TYPE;